import React, { useEffect } from "react";
import { Contact } from "../../components/ui/Contact";
import { SiteFrame } from "../../components/ui/SiteFrame";
import Mixpanel from "../../lib/mixpanel";
import Seo from "../../components/Seo";

export default function ContactPage() {
  useEffect(() => {
    Mixpanel.trackContact();
  }, []);

  return (
    <SiteFrame>
      <Seo
        title="Contact"
        path="/contact"
        description="Get in touch with Krushil Amrutiya — reach out via email or connect on GitHub, LinkedIn, and X."
      />
      <Contact />
    </SiteFrame>
  );
}
